/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PSPulse API
 * South Tyrol Pronto Soccorso queue data — with a memory: history, trends, and forecasts. Data source: the CC0 PS_Queue feed from Open Data Südtirol (https://dati.retecivica.bz.it/). Tier-1 read endpoints (live overview, per-hospital history, day×hour heatmap, estimated wait) are live; the estimated-wait figures are deliberately rough, drain-rate estimates.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  RegionTrendResponse
} from '../model';

import { customAxiosInstance } from '../../axios-instance.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns the regional people-waiting curve for today (by Europe/Rome local hour) and the historical typical band (p25/avg/p75) for the same day-of-week, aggregated across all 7 South Tyrol ERs. Units are people waiting (the honest, feed-provided unit — not estimated wait times). Band values are null when fewer than 2 weekly observations exist for a slot (sparse history is disclosed, never fabricated). No forecast fields are present (Tier-2 feature). Powers the Overview 'oggi vs tipico' hero chart.
 * @summary Regional today-vs-typical trend
 */
export const getRegionTrend = (

 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {


      return customAxiosInstance<RegionTrendResponse>(
      {url: `/region/trend`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }




export const getGetRegionTrendQueryKey = () => {
    return [
    `/region/trend`
    ] as const;
    }


export const getGetRegionTrendQueryOptions = <TData = Awaited<ReturnType<typeof getRegionTrend>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionTrend>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegionTrendQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegionTrend>>> = ({ signal }) => getRegionTrend(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegionTrend>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRegionTrendQueryResult = NonNullable<Awaited<ReturnType<typeof getRegionTrend>>>
export type GetRegionTrendQueryError = unknown


export function useGetRegionTrend<TData = Awaited<ReturnType<typeof getRegionTrend>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionTrend>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegionTrend>>,
          TError,
          Awaited<ReturnType<typeof getRegionTrend>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRegionTrend<TData = Awaited<ReturnType<typeof getRegionTrend>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionTrend>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegionTrend>>,
          TError,
          Awaited<ReturnType<typeof getRegionTrend>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRegionTrend<TData = Awaited<ReturnType<typeof getRegionTrend>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionTrend>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Regional today-vs-typical trend
 */

export function useGetRegionTrend<TData = Awaited<ReturnType<typeof getRegionTrend>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionTrend>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRegionTrendQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






